import { render } from "./500.vue?vue&type=template&id=0c8a6198&scoped=true&ts=true"
import script from "./500.vue?vue&type=script&lang=ts"
export * from "./500.vue?vue&type=script&lang=ts"

import "./500.vue?vue&type=style&index=0&id=0c8a6198&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c8a6198"]])

export default __exports__